(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aylam-branch-to-bottle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aylam-process-video')) {
    class AylamProcessVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggleButton = this.querySelector('[data-process-toggle]');

        if (!this.video || !this.toggleButton) return;

        this.updateControl = (isPlaying) => {
          const label = isPlaying
            ? this.toggleButton.dataset.pauseLabel
            : this.toggleButton.dataset.playLabel;
          this.toggleButton.setAttribute('aria-label', label);
          this.classList.toggle('is-playing', isPlaying);
          if (!isPlaying) this.hideControl();
        };

        this.video.addEventListener('play', () => {
          this.closest('.aylam-process').querySelectorAll('aylam-process-video video').forEach((video) => {
            if (video !== this.video) video.pause();
          });
          this.updateControl(true);
        });

        this.video.addEventListener('pause', () => this.updateControl(false));

        this.video.addEventListener('ended', () => {
          if (this.dataset.loop !== 'true') this.updateControl(false);
        });

        this.video.addEventListener('click', () => this.revealControlTemporarily());

        this.toggleButton.addEventListener('click', (event) => {
          event.stopPropagation();
          if (this.video.paused) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        });

        if (this.closest('[data-process-step]').classList.contains('is-active')) {
          this.activate();
        }
      }

      activate() {
        if (!this.video || this.dataset.autoplay !== 'true') return;
        this.video.muted = true;
        this.video.play().catch(() => this.updateControl(false));
      }

      deactivate() {
        if (this.video && !this.video.paused) this.video.pause();
        this.hideControl();
      }

      revealControlTemporarily() {
        if (!this.video || this.video.paused) return;
        window.clearTimeout(this.controlTimer);
        this.classList.add('is-control-visible');
        this.controlTimer = window.setTimeout(() => this.hideControl(), 2200);
      }

      hideControl() {
        window.clearTimeout(this.controlTimer);
        this.classList.remove('is-control-visible');
      }
    }

    customElements.define('aylam-process-video', AylamProcessVideo);
  }

  if (!customElements.get('aylam-process-accordion')) {
    class AylamProcessAccordion extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-process-step]'));

        this.steps.forEach((step, index) => {
          const trigger = step.querySelector('[data-process-trigger]');

          trigger.addEventListener('click', () => {
            if (!step.classList.contains('is-active')) this.setActive(index);
          });
          trigger.addEventListener('keydown', (event) => this.handleArrowKey(event, index));

          step.addEventListener('click', (event) => {
            if (!step.classList.contains('is-active') && !event.target.closest('[data-process-trigger]')) {
              this.setActive(index);
            }
          });

          step.addEventListener('shopify:block:select', () => this.setActive(index));
        });

        const initialIndex = Math.max(0, this.steps.findIndex((step) => step.classList.contains('is-active')));
        this.setActive(initialIndex);
      }

      setActive(activeIndex) {
        this.steps.forEach((step, index) => {
          const isActive = index === activeIndex;
          const trigger = step.querySelector('[data-process-trigger]');
          const panel = step.querySelector('[data-process-panel]');
          const video = step.querySelector('aylam-process-video');

          step.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          panel.inert = !isActive;

          if (!video) return;
          if (isActive) {
            video.activate();
          } else {
            video.deactivate();
          }
        });
      }

      handleArrowKey(event, currentIndex) {
        const previousKeys = ['ArrowLeft', 'ArrowUp'];
        const nextKeys = ['ArrowRight', 'ArrowDown'];
        if (!previousKeys.includes(event.key) && !nextKeys.includes(event.key)) return;

        event.preventDefault();
        const direction = previousKeys.includes(event.key) ? -1 : 1;
        const nextIndex = (currentIndex + direction + this.steps.length) % this.steps.length;
        this.setActive(nextIndex);
        this.steps[nextIndex].querySelector('[data-process-trigger]').focus();
      }
    }

    customElements.define('aylam-process-accordion', AylamProcessAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aylam-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyWithSelection = text => {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      field.remove();
      return copied;
    };

    const copyText = text => {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(() => true, () => copyWithSelection(text));
      }

      return Promise.resolve(copyWithSelection(text));
    };

    const initSlider = slider => {
      if (slider.dataset.aylamHeroInitialized === 'true') {
        return;
      }

      const slides = Array.from(slider.querySelectorAll('[data-aylam-hero-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-aylam-hero-dot]'));
      const previousButton = slider.querySelector('[data-aylam-hero-previous]');
      const nextButton = slider.querySelector('[data-aylam-hero-next]');

      if (!slides.length) {
        return;
      }

      slider.dataset.aylamHeroInitialized = 'true';
      let activeIndex = 0;
      let timer = null;

      const setActive = index => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          slide.querySelectorAll('a[href], button').forEach(element => {
            element.tabIndex = isActive ? 0 : -1;
          });
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.remove('is-active');
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');

          if (isActive) {
            void dot.offsetWidth;
            dot.classList.add('is-active');
          }
        });
      };

      const stop = () => {
        slider.classList.add('is-paused');

        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        if (slides.length < 2 || slider.dataset.autoplay !== 'true') {
          slider.classList.add('is-paused');
          return;
        }

        stop();
        slider.classList.remove('is-paused');
        timer = window.setInterval(() => setActive(activeIndex + 1), Number(slider.dataset.interval || 5000));
      };

      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.slideIndex || 0));
          start();
        });
      });

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          setActive(activeIndex - 1);
          start();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          setActive(activeIndex + 1);
          start();
        });
      }

      slider.querySelectorAll('[data-aylam-hero-code]').forEach(button => {
        const status = button.querySelector('[data-aylam-hero-code-status]');
        const copyLabel = status ? status.textContent : '';
        let resetTimer = null;

        button.addEventListener('click', () => {
          copyText(button.dataset.aylamHeroCode).then(copied => {
            if (!copied || !status) {
              return;
            }

            status.textContent = button.dataset.copiedLabel || copyLabel;
            button.classList.add('is-copied');
            window.clearTimeout(resetTimer);
            resetTimer = window.setTimeout(() => {
              status.textContent = copyLabel;
              button.classList.remove('is-copied');
            }, 2000);
          });
        });
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      setActive(0);
      start();
    };

    const initAll = root => {
      root.querySelectorAll('[data-aylam-hero-slider]').forEach(initSlider);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
